<script>

import mModal from './modalDialog.vue'

export default {
  name: 'hearingNum',
  components: {mModal},
  props: {
    leftNum: {},
    rightNum: {}
  },
  data () {
    return {
      imgQuestion: require('../assets/question.svg'),
      showModal: false,
      dataValueLeft: (this.leftNum > 0 ? this.leftNum + ' dB HL' : this.leftNum),
      dataValueRight: (this.rightNum > 0 ? this.rightNum + ' dB HL' : this.rightNum)
    }
  },
  methods: {
    showType () {
      this.showModal = true
    },
    // 接收子组件的传值,并更改父组件的数据
    setModal (data) {
      this.showModal = data
    }
  }
}
</script>

<template>
  <div class="flex-box">
    <div class="titleTextBox">Your Hearing Number
      <button @click='showType' style="background: transparent; border: none;">
        <img :src="imgQuestion" style="width: 24px; height: 24px; "/>
      </button>
      <m-modal :show="showModal" v-on:listenToChildEvent="setModal">
        <h3 slot="header">Your Hearing Number</h3>
        <h slot="content">
          Your Hearing Number indicates how loud sounds must be for you to hear them. The higher your Hearing Number,
          the louder sounds will need to be. The Hearing Number, which ranges from about 0 to 100dB, is the average of
          your results from 500 Hz to 4000Hz for each ear. Your Hearing Number can guide you to various hearing
          strategies and potentially helpful technologies.
        </h>
      </m-modal>
    </div>

    <div class="contentText">
      <div class="blueBlock"></div>
      <div class="textBoxBlue">Left</div>
      <div class="textNormal">{{ dataValueLeft }}</div>
      <div class="redBlock"></div>
      <div class="textBoxRed">Right</div>
      <div class="textNormal">{{ dataValueRight }}</div>
    </div>
    <div class="contentText-small">
      <div class="contentText-column-small">
        <div class="contentText-title-small">
          <div class="blueBlock"></div>
          <div class="textBoxBlue">Left</div>
        </div>
        <div class="textNormalBlue">{{ dataValueLeft }}</div>
      </div>

      <div class="contentText-column-small">
        <div class="contentText-title-small">
          <div class="redBlock"></div>
          <div class="textBoxRed">Right</div>
        </div>
        <div class="textNormalRed">{{ dataValueRight }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.contentText, .contentText-small{
  display: none;
}

@media (min-width: 901px) {
  .contentText{
    display: flex;
    flex-direction: row;
    text-align: left;
    margin-left: 30px;
    margin-bottom: 20px;
    margin-top: 10px;
  }
}

@media (max-width: 768px) {
  .contentText-small{
    display: flex;
    flex-direction: row;
    text-align: left;
  }

  .contentText-title-small{
    display: flex;
    flex-direction: row;
    text-align: left;
    margin-left: 30px;
    margin-top: 10px;
  }

  .contentText-column-small{
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: 10px;
    margin-bottom: 20px;
    margin-top: 10px;
  }
}

@media (max-width: 375px) {
  .contentText-column-small{
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-bottom: 20px;
    margin-top: 10px;
    margin-left: -1px;
  }
}

.flex-box {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  background: #f8f8f8;
  border-radius: 10px;
}

.titleTextBox {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  font-size: 24px;
  line-height: 30px;
  text-align: left;
  padding-left: 30px;
  padding-right: 20px;
  padding-bottom: 10px;
  margin-top: 20px;
}

.textBoxRed {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  font-size: 24px;
  line-height: 30px;
  text-align: left;
  color: #f64646;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
}

.textBoxBlue {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  font-size: 24px;
  line-height: 30px;
  text-align: left;
  color: #003399;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
}

.textNormal {
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  font-size: 24px;
  line-height: 30px;
  text-align: left;
  color: #686868;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

.blueBlock {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background-color: #003399;
}

.redBlock {
  margin-left: 50px;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  background-color: #f64646;
}

@media (max-width: 768px) {

  .titleTextBox {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 20px;
    line-height: 30px;
    text-align: left;
    padding-left: 20px;
    padding-right: 5px;
    padding-bottom: 10px;
    margin-top: 20px;
  }

  .textBoxRed {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 25px;
    line-height: 25px;
    text-align: left;
    color: #f64646;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
  }

  .textBoxBlue {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 25px;
    line-height: 25px;
    text-align: left;
    color: #003399;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
  }

  .textNormalBlue {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 25px;
    line-height: 30px;
    text-align: left;
    font-weight: 400;
    color: #003399;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    margin-top: 10px;
  }

  .textNormalRed {
    font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
    font-size: 25px;
    font-weight: 400;
    line-height: 30px;
    text-align: left;
    color: #f64646;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 40px;
    margin-top: 10px;
  }

  .blueBlock {
    width: 25px;
    height: 25px;
    border-radius: 5px;
    background-color: #003399;
    margin-left: -10px;
  }

  .redBlock {
    margin-left: 15px;
    width: 25px;
    height: 25px;
    border-radius: 5px;
    background-color: #f64646;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/HearingNum.vue